<template>
  <v-toolbar style="margin-bottom: 20px">
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <v-toolbar-title>{{ title }}</v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  name: "ListItemToolbar",
  props: {
    title: String
  }
};
</script>
